import { api } from './api';
import type { Model, ModelsResponse, Provider } from '@/types/api';

export async function listModels(): Promise<ModelsResponse> {
  const { data } = await api.get<ModelsResponse>('/api/v1/models');
  return data;
}

export async function listModelsForProvider(provider: Provider): Promise<Model[]> {
  const { data } = await api.get<{ provider: Provider; models: Model[] }>(`/api/v1/models/${provider}`);
  return data.models ?? [];
}
